import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/lib/locale/pt';
import en from 'vuetify/lib/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt, en },
    current: 'pt',
  },
  theme: {
    themes: {
      light: {
        primary: '#0277BD',
        secondary: '#00BDB3',
      },
    },
  },
});
